export function HsyOrderService (
  $window,
  API,
  sessionObjAPI
) {
  var HsyOrder = function (vendor, reference_type) {
    this.origin         = sessionObjAPI.base().origin;
    this.vendor         = vendor ||  {};
    this.reference_type = reference_type;

  };

  HsyOrder.prototype.buildQuery = function (url, order) {
    const self = this;

    return $.param({
      action: 'order',
      hookUrl: url,
      order_id: order.id,
      orderno: order.job_card_number,
      parts: order.purchase_order_items_attributes.map(item => {
        return {
          hsyno: item.hsy_number,
          oerefno: item.item_code,
          description: item.description,
          qty: item.quantity_ordered,
          unitprice: item.unit_cost,
          comments: ''
        };
      }),
      quoteref: order.hsy_quote_number,
      return_url: `${API.url}/purchase_orders/update_and_process_order_from_hsy/${order.id}`
    });
  };

  HsyOrder.prototype.getUrl = function (order) {
    const self = this;

    return `${self.origin}workshop.html#/${self.vendor.id}/purchase_order/${order.id}`;
  };

  HsyOrder.prototype.sendOrder = function(order) {
    const self      = this;

    var url         = self.getUrl(order.order);
    var queryString = self.buildQuery(url, order.order);

    $window.location.assign(`/hsy.html?${queryString}`);
  };

  return HsyOrder;
}
